import React from "react";

import SchedulingTimeslotItemRenderer from "./SchedulingTimeslotItemRenderer";
import { MAX_TIMELINE_Z_INDEX } from "../../../constants/fast";
import { getTimelineItemPaddings } from "../../../utils/fast";

import type { CSSProperties, JSX, MutableRefObject } from "react";

import type {
  SchedulingTimeslotItem,
  TimelineItemRendererProps,
  TimelineRef,
} from "./timeline.types";

interface SchedulingHeaderItemRendererProps extends TimelineItemRendererProps<SchedulingTimeslotItem> {
  timelineRef: MutableRefObject<TimelineRef | null>;
}

function HeaderItemRenderer({
  itemContext,
  getItemProps,
  item,
  timelineRef,
}: SchedulingHeaderItemRendererProps): JSX.Element | null {
  const isVerticalTimeline = timelineRef?.current?.props.isVertical ?? false;

  const styleContainerItem: CSSProperties = {
    background: "transparent",
    border: "none",
  };

  const itemProps = getItemProps({
    style: styleContainerItem,
  });

  const { style, key } = itemProps;

  return (
    <div
      key={key}
      style={{
        ...style,
        lineHeight: "unset",
        cursor: "default",
        zIndex: MAX_TIMELINE_Z_INDEX,
        height: undefined,
        ...getTimelineItemPaddings({ isVerticalTimeline, width: style.width }),
      }}
    >
      <SchedulingTimeslotItemRenderer
        isVerticalTimeline={isVerticalTimeline}
        item={item}
        itemContext={itemContext}
        itemProps={itemProps}
      />
    </div>
  );
}

export default HeaderItemRenderer;
